import translationStore          from '@widesk-ui/stores/translationStore';
import modelsFr                  from '@/models/localization/fr.json';
import { setModelLocalizedData } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import { setLocale }             from '@widesk-core/locale';
import { setWorkerUrl }          from 'maplibre-gl';
import maplibreWorkerUrl         from 'maplibre-gl/dist/maplibre-gl-worker.mjs?url';

// MapLibre déduit l'adresse de son worker de la sienne au moment de l'exécution : le build ne voit
// pas ce fichier, ne l'émet pas, et la carte ne charge plus. Le `?url` le fait émettre par Vite.
setWorkerUrl(maplibreWorkerUrl);

setLocale('fr');

setModelLocalizedData(modelsFr);

const translations = {
	fr: { 'title': 'Français', 'image': '/flags/fr.png' },
	en: { 'title': 'Anglais', 'image': '/flags/en.png' },
};

translationStore.setTranslations(translations);
